export const formats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
  'image',
  'color',
  'background',
  'script',
  'code-block',
  'direction',
  'align',
  'font',
  'size',
  'video',
  'formula',
  // 'imageBlot',
];

export const modules = {
  toolbar: {
    container: [
      [{ font: [] }, { size: ['small', false, 'large', 'huge'] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ color: [] }, { background: [] }],
      [{ script: 'super' }, { script: 'sub' }],
      [{ header: 1 }, { header: 2 }, 'blockquote', 'code-block'],
      [
        { list: 'ordered' },
        { list: 'bullet' },
        { indent: '-1' },
        { indent: '+1' },
        { direction: 'rtl' },
        { align: [] },
      ],
      ['link', 'image', 'video', 'formula'],
      ['clean'],
    ],
  },
};
